/**
 * created by hezq on 2019-10-24
 *
 * description：公共常量
 */

const common = {
	PLAT: [{
		sid: 'M11160',
		name: '供应商评价'
	}, {
		sid: 'M11220',
		name: '框架协议'
	}]
};

export default common;



// WEBPACK FOOTER //
// ./src/consts/common/index.js